import { createRouter , createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/home',
    meta: {
      title: '导航',
    }
  },
  {
    path: '/home',
    name: 'home',
    component:() => import('../views/homeV3/homeV3.vue'),
    meta: {
      title: '导航',
    }
  },
  {
    path: '/login',
    name: 'login',
    component:() => import('../views/login/loginIndex.vue'),
    meta: {
      title: '登录',
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component:() => import('../views/settings/settingsIndex.vue'),
    meta: {
      title: '设置',
    }
  },
  {
    path: '/register',
    name: 'register',
    component:() => import('../views/register/registerIndex.vue'),
    meta: {
      title: '注册',
    }
  },
  {
    path: '/task',
    name: 'task',
    component:() => import('../views/task/taskIndex.vue'),
    meta: {
      title: '任务管理',
    }
  },
  {
    path: '/resources',
    name: 'resources',
    component:() => import('../views/resources/resourcesIndex.vue'),
    meta: {
      title: '资源下载',
    }
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component:() => import('../views/forgotPassword/forgotPassword.vue'),
    meta: {
      title: '忘记密码',
    }
  },
  {
    path: '/oidc/callback',
    name: 'oidcCallback',
    component:() => import('../views/login/oidcCallback.vue'),
    meta: {
      title: '统一认证登录',
    }
  },
  {
    path: '/v2',
    name: 'v2',
    redirect: '/home',
    meta: {
      title: '主页',
    }
  },
  {
    path: '/v3',
    name: 'v3',
    redirect: '/home',
    meta: {
      title: '主页',
    }
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
